import React from 'react';

function BadgeGroup({ children }) {
    return (
        <>
            <div className="skill-group justify-center md:justify-start">{children}</div>
        </>
    );
}

export default BadgeGroup;
